/** Blur + saturation applied to every glass panel. */
export const glassBlur = 'blur(20px) saturate(140%)'

/**
 * Style props that turn a Box into a glass panel.
 *
 * Light mode is unchanged — a plain white card with a soft shadow. Dark mode
 * swaps the fill for a white alpha, blurs whatever is behind it and adds a lit
 * hairline edge, so the panel reads as frosted glass over the page wash.
 *
 * Spread it first so callers can still override `bg`, `borderRadius`, etc.:
 *
 * ```tsx
 * <Box {...glassPanel} bg="card.royal.5" />
 * ```
 */
export const glassPanel = {
  bg: 'bg.glass',
  borderStyle: 'solid',
  borderWidth: { base: '0px', _dark: '1px' },
  borderColor: { base: 'transparent', _dark: 'border.glass' },
  backdropFilter: { _dark: glassBlur },
  boxShadow: 'card',
} as const

/** Denser variant for panels that sit on top of another glass panel. */
export const glassPanelRaised = {
  ...glassPanel,
  bg: 'bg.glass.raised',
} as const
